import {AppBar, Box} from '@mui/material';
import React from 'react';
import LogoPerseo from 'src/assets/logo-cv.png';

function Header() {
	return (
		<AppBar position="static" color="transparent" elevation={0} data-testid="header">
			<Box sx={{
				backgroundColor: 'grey.100',
				display: 'flex',
				justifyContent: 'end',
				padding: '1.2rem',
			}}
			>
				<img
					src={LogoPerseo}
					alt="Logo Perseo"
					width="300"
				/>
			</Box>
		</AppBar>
	);
}

export default Header;
